// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28-iq","colMin":"styles_colMin__3Jbhm"};